import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { clienteCadastros } from '../../../../home/pessoa/cliente/cadastro/cliente-cadastro';
import { CustomControlValueAccessor } from '../../utils/custom-control-value-accessor/custom-control-value-accessor';
import { IMultiSelectSettings } from '../multi-select/models/multi-select-settings.interface';
import { IOption } from '../multi-select/models/option.interface';

@Component({
  selector: 'sgt-novo-cliente-cadastro-multi-select',
  templateUrl: './novo-cliente-cadastro-multiselect.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NovoClienteCadastroMultiselectComponent),
      multi: true
    }
  ]
})
export class NovoClienteCadastroMultiselectComponent extends CustomControlValueAccessor<
  number[]
> implements OnInit {
  @Input() idsCadastros: number[];
  @Input() variante: 'filtro' | undefined;
  @Input() icon = 'fa-address-card';
  @Output() idsCadastrosChange = new EventEmitter<number[]>();

  options: IOption[] = [];
  settings: IMultiSelectSettings = {
    placeholder: 'Cadastros',
    plural: 'Cadastros',
    singular: 'Cadastro',
    searchEmptyResultMessage: 'Nenhum cadastro encontrado',
    showFooter: true
  };

  ngOnInit() {
    const ids = this._value ?? this.idsCadastros ?? [];
    this.options = clienteCadastros.map((cadastro) => ({
      id: cadastro.id,
      label: cadastro.nome,
      isChecked: ids.includes(cadastro.id)
    }));
  }

  protected updateValue(newValue: number[] | null): void {
    this.idsCadastros = newValue ?? [];
    this.options.forEach((o) => {
      o.isChecked = this.idsCadastros.includes(o.id);
    });
  }

  onSelectionChange() {
    this.emitChange(this.idsCadastros);
    this.markAsTouched();
  }

  onSelected() {
    this.idsCadastrosChange.emit(this.idsCadastros);
  }
}
